module.exports = __webpack_public_path__ + "img/fx-white.9a480683.png";